import { Pool } from "@/models/pool.model";

export const getRename = (
  pool: Pool,
  ioType: number,
  ioIndex: number
): string | undefined => {
  return pool.IORename?.find(
    (ioRename) => ioRename.ioType === ioType && ioRename.ioIndex === ioIndex
  )?.name;
};
